
import { PersonValidationEntity } from "infrastructure/services/types/enrollments.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  selfie: '',
  selfieRaw: '',
  userId: '',
  merchantIdScanReference: '',
  templateRaw: '',
} as PersonValidationEntity;

export const enrollmentPersonValidationReducer = createSlice({
  name: "EnrollmentPersonValidationReducer",
  initialState,
  reducers: {
    savePersonValidation: (state, action: PayloadAction<PersonValidationEntity>) => {
      return action.payload;
    },
    resetPersonValidation: () => {
      return initialState;
    },
  },
});

export const { resetPersonValidation, savePersonValidation } = enrollmentPersonValidationReducer.actions;

export const getEnrollmentPersonValidationRedux = (state: RootState) => { return state };

export default enrollmentPersonValidationReducer.reducer;
